import switchFunc from 'lib/function/switchFunc'

import type { SvgIconProps } from 'LuxKit/SvgIcon'

import LineArrowsCompareHorizontalIcon from 'LuxKit/Icons/line/LineArrowsCompareHorizontalIcon'
import LineAtIcon from 'LuxKit/Icons/line/LineAtIcon'
import LineBookmarkFullIcon from 'LuxKit/Icons/line/LineBookmarkFullIcon'
import LineCalendarCheckIcon from 'LuxKit/Icons/line/LineCalendarCheckIcon'
import LineCalendarPlusIcon from 'LuxKit/Icons/line/LineCalendarPlusIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineChatBubbleUserIcon from 'LuxKit/Icons/line/LineChatBubbleUserIcon'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import LineClockNineIcon from 'LuxKit/Icons/line/LineClockNineIcon'
import LineCoffeeIcon from 'LuxKit/Icons/line/LineCoffeeIcon'
import LineCommentAltIcon from 'LuxKit/Icons/line/LineCommentAltIcon'
import LineCommentMessageIcon from 'LuxKit/Icons/line/LineCommentMessageIcon'
import LineCommentsIcon from 'LuxKit/Icons/line/LineCommentsIcon'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import LineCornerDownRightAltIcon from 'LuxKit/Icons/line/LineCornerDownRightAltIcon'
import LineDocumentInfoIcon from 'LuxKit/Icons/line/LineDocumentInfoIcon'
import LineDollarSignIcon from 'LuxKit/Icons/line/LineDollarSignIcon'
import LineEnvelopeAltIcon from 'LuxKit/Icons/line/LineEnvelopeAltIcon'
import LineEnvelopeCheckIcon from 'LuxKit/Icons/line/LineEnvelopeCheckIcon'
import LineFastMailIcon from 'LuxKit/Icons/line/LineFastMailIcon'
import LineFlightCreditIcon from 'LuxKit/Icons/line/LineFlightCreditIcon'
import LineKeySkeletonIcon from 'LuxKit/Icons/line/LineKeySkeletonIcon'
import LineListOlAltIcon from 'LuxKit/Icons/line/LineListOlAltIcon'
import LineMobileAndroidIcon from 'LuxKit/Icons/line/LineMobileAndroidIcon'
import LineNotesIcon from 'LuxKit/Icons/line/LineNotesIcon'
import LinePhoneAltIcon from 'LuxKit/Icons/line/LinePhoneAltIcon'
import LinePlusIcon from 'LuxKit/Icons/line/LinePlusIcon'
import LineScheduleIcon from 'LuxKit/Icons/line/LineScheduleIcon'
import LineSearchPlusIcon from 'LuxKit/Icons/line/LineSearchPlusIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineTimesCircleIcon from 'LuxKit/Icons/line/LineTimesCircleIcon'
import LineUserCheckIcon from 'LuxKit/Icons/line/LineUserCheckIcon'
import LineUserCircleIcon from 'LuxKit/Icons/line/LineUserCircleIcon'
import LineUserExclamationIcon from 'LuxKit/Icons/line/LineUserExclamationIcon'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import LineUserPlusIcon from 'LuxKit/Icons/line/LineUserPlusIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LineHouseIcon from 'LuxKit/Icons/line/LineHouseIcon'
import LineBusIcon from 'LuxKit/Icons/line/LineBusIcon'
import LinePlaneIcon from 'LuxKit/Icons/line/LinePlaneIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import InsuranceIcon from 'LuxKit/Icons/custom/InsuranceIcon'
import LineUsersMultiIcon from 'LuxKit/Icons/line/LineUsersMultiIcon'
import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import LineFileExclamationIcon from 'LuxKit/Icons/line/LineFileExclamationIcon'
import LineDownloadAltIcon from 'LuxKit/Icons/line/LineDownloadAltIcon'
// These are the icons that are present in the LESA Figma file.
// Not all the associated chat categories exist yet.
const LESA_ICONS: Record<
  string,
  React.FunctionComponent<SvgIconProps>
> = {
  arrowsCompareHorizontal: LineArrowsCompareHorizontalIcon,
  at: LineAtIcon,
  bookmarkFull: LineBookmarkFullIcon,
  calendarCheck: LineCalendarCheckIcon,
  calendarPlus: LineCalendarPlusIcon,
  car: LineCarIcon,
  ticket: LineTicketIcon,
  chatBubbleUser: LineChatBubbleUserIcon,
  check: LineCheckIcon,
  clockNine: LineClockNineIcon,
  coffee: LineCoffeeIcon,
  commentAlt: LineCommentAltIcon,
  commentMessage: LineCommentMessageIcon,
  comments: LineCommentsIcon,
  compass: LineCompassIcon,
  cornerDownRightAlt: LineCornerDownRightAltIcon,
  ship: LineShipIcon,
  documentInfo: LineDocumentInfoIcon,
  dollarSign: LineDollarSignIcon,
  downloadTaxInvoice: LineDownloadAltIcon,
  envelopeAlt: LineEnvelopeAltIcon,
  envelopeCheck: LineEnvelopeCheckIcon,
  fastMail: LineFastMailIcon,
  flightCredit: LineFlightCreditIcon,
  house: LineHouseIcon,
  keySkeleton: LineKeySkeletonIcon,
  listOlAlt: LineListOlAltIcon,
  mobileAndroid: LineMobileAndroidIcon,
  notes: LineNotesIcon,
  phoneAlt: LinePhoneAltIcon,
  plus: LinePlusIcon,
  schedule: LineScheduleIcon,
  searchPlus: LineSearchPlusIcon,
  star: LineStarIcon,
  timesCircle: LineTimesCircleIcon,
  bus: LineBusIcon,
  user: LineUserIcon,
  userCheck: LineUserCheckIcon,
  userCircle: LineUserCircleIcon,
  userExclamation: LineUserExclamationIcon,
  userPlus: LineUserPlusIcon,
  luxPlus: LinePhoneIcon,
  loyalty: LinePhoneIcon,
  plane: LinePlaneIcon,
  insurance: InsuranceIcon,
  usersMulti: LineUsersMultiIcon,
  mapMarker: LineMapMarkerIcon,
  fileExclamation: LineFileExclamationIcon,
}

// Map chat category keys to customer portal icons.
// only some chat categories have been assigned icons so far.
const MESSAGE_CATEGORY_MAP: Partial<Record<App.ChatContentCategories, string>> = {
  airportTransfers: 'plane',
  airportTransfersPurchase: 'plus',
  airportTransfersBook: 'calendarCheck',
  airportTransfersEmpty: 'plane',
  airportTransfersMissing: 'plane',
  airportTransfersForm: 'plane',
  airportTransfersOrderList: 'plane',
  cancel: 'timesCircle',
  chatAgent: 'chatBubbleUser',
  chatNew: 'plus',
  chatLesa: 'comments',
  chatRecent: 'commentAlt',
  confirm: 'check',
  cruiseEnquiry: 'ship',
  downloadTaxInvoice: 'downloadTaxInvoice',
  frequentFlyer: 'flightCredit',
  hotelEnquiry: 'house',
  order: 'calendarCheck',
  orderCancel: 'timesCircle',
  orderAddDates: 'calendarPlus',
  orderChangeDates: 'schedule',
  orderChangeRoom: 'arrowsCompareHorizontal',
  orderFinePrint: 'documentInfo',
  orderInclusions: 'coffee',
  orderItemList: 'listOlAlt',
  orderList: 'calendarCheck',
  orderNew: 'searchPlus',
  orderResendConfirmation: 'envelopeCheck',
  flightsElectronicTickets: 'ticket',
  other: 'commentMessage',
  paymentIssues: 'dollarSign',
  redirectMyEscapes: 'cornerDownRightAlt',
  requestAgentCallback: 'phoneAlt',
  tourEnquiry: 'bus',
  userEmail: 'envelopeAlt',
  userPhone: 'phoneAlt',
  userLogIn: 'userPlus',
  userLogInIssue: 'userExclamation',
  userLogInPhone: 'mobileAndroid',
  userPasswordReset: 'keySkeleton',
  userUpdate: 'userCheck',
  userUpdateEmail: 'at',
  userUpdateName: 'userCircle',
  userUpdatePhone: 'phoneAlt',
  userUpdateSubscription: 'envelopeAlt',
  luxPlusPrioritySupport: 'luxPlus',
  loyaltyPrioritySupport: 'loyalty',
  carHire: 'car',
  flightOrderList: 'plane',
  insurance: 'star',
  extraGuests: 'usersMulti',
  orderListExtraGuests: 'usersMulti',
  orderItemsListExtraGuests: 'usersMulti',
  nlsSearchHotels: 'house',
  nlsViewAllHotels: 'house',
  viewMap: 'mapMarker',
  shareBooking: 'userPlus',
  specialRequest: 'fileExclamation',
  changeGuestName: 'userCircle',
  requestDateChange: 'schedule',
  requestRefund: 'timesCircle',
}
const actionSwitch = switchFunc(LESA_ICONS, undefined)

export function getActionIcon(value: App.ChatContentCategories) {
  const key = MESSAGE_CATEGORY_MAP[value]
  if (!key) return

  return actionSwitch(key)
}
